<template>
  <section class="portfolio" id="portfolio">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="title">
            <h5>{{ t("Enough Talking, Let's See What Matters The Most.") }}</h5>
            <h1 class="mb-4">{{ t("What We've Done So Far") }}</h1>
            <p>{{ t("Despite being a fresh startup, we've experiences working with big brands and corporates. Check out our previous project, or simply take a look of our own website. You can certainly feel the differences.") }}</p>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="project new">
            <figure>
              <img :src="'/images/ui/screenshots/lianhuat.webp'" alt="lianhuat.com" />
              <a href="https://lianhuat.com/" target="_blank" rel="noopener">
                {{ t('Visit Website') }}
              </a>
            </figure>
            <a href="https://lianhuat.com/" target="_blank" rel="noopener">
              <h5 class="mb-0">lianhuat.com</h5>
            </a>
            <p>{{ t('Business') }}, {{ t('Informational') }}, {{ t('Portal') }}, {{ t('Catalog') }}</p>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="project new">
            <figure>
              <img :src="'/images/ui/screenshots/adsolute.webp'" alt="adsolute.my" />
              <a href="https://adsolute.my/" target="_blank" rel="noopener">
                {{ t('Visit Website') }}
              </a>
            </figure>
            <a href="https://adsolute.my/" target="_blank" rel="noopener">
              <h5 class="mb-0">adsolute.my</h5>
            </a>
            <p>{{ t('Business') }}, {{ t('Informational') }}</p>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="project new">
            <figure>
              <img :src="'/images/ui/screenshots/artcrafts.webp'" alt="artcrafts.io" />
              <a href="https://artcrafts.io/" target="_blank" rel="noopener">
                {{ t('Visit Website') }}
              </a>
            </figure>
            <a href="https://artcrafts.io/" target="_blank" rel="noopener">
              <h5 class="mb-0">artcrafts.io</h5>
            </a>
            <p>{{ t('Business') }}, {{ t('Informational') }}</p>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="project">
            <figure>
              <img :src="'/images/ui/screenshots/punch.webp'" alt="punch.my" />
              <a href="https://punch.my/" target="_blank" rel="noopener">
                {{ t('Visit Website') }}
              </a>
            </figure>
            <a href="https://punch.my/" target="_blank" rel="noopener">
              <h5 class="mb-0">punch.my</h5>
            </a>
            <p>{{ t('Educational') }}, {{ t('Portal') }}, {{ t('Catalog') }}</p>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="project">
            <figure>
              <img :src="'/images/ui/screenshots/pintarcerdik.webp'" alt="pintarcerdik.com.my" />
              <a href="https://pintarcerdik.com.my/" target="_blank" rel="noopener">
                {{ t('Visit Website') }}
              </a>
            </figure>
            <a href="https://pintarcerdik.com.my/" target="_blank" rel="noopener">
              <h5 class="mb-0">pintarcerdik.com.my</h5>
            </a>
            <p>{{ t('Educational') }}, {{ t('Portal') }}, {{ t('Catalog') }}</p>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="project">
            <figure>
              <img :src="'/images/ui/screenshots/printxpress.webp'" alt="printxpress.com.my" />
              <a href="https://printxpress.vxms.dev/" target="_blank" rel="noopener">
                {{ t('Visit Website') }}
              </a>
            </figure>
            <a href="https://printxpress.vxms.dev/" target="_blank" rel="noopener">
              <h5 class="mb-0">printxpress.com.my</h5>
            </a>
            <p>{{ t('Business') }}, {{ t('E-Commerce') }}</p>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="project">
            <figure>
              <img :src="'/images/ui/screenshots/fongwahprint.webp'" alt="fongwahprint.com.my" />
              <a href="https://fongwahprint.vxms.dev/" target="_blank" rel="noopener">
                {{ t('Visit Website') }}
              </a>
            </figure>
            <a href="https://fongwahprint.vxms.dev/" target="_blank" rel="noopener">
              <h5 class="mb-0">fongwahprint.com.my</h5>
            </a>
            <p>{{ t('Business') }}, {{ t('Informational') }}, {{ t('Catalog') }}</p>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="project">
            <figure>
              <img :src="'/images/ui/screenshots/yeasytrip.webp'" alt="yeasytrip.com" />
              <a href="https://yeasytrip.com/" target="_blank" rel="noopener">
                {{ t('Visit Website') }}
              </a>
            </figure>
            <a href="https://yeasytrip.com/" target="_blank" rel="noopener">
              <h5 class="mb-0">yeasytrip.com</h5>
            </a>
            <p>{{ t('Business') }}, {{ t('E-Commerce') }}</p>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="project">
            <figure>
              <img :src="'/images/ui/screenshots/wonderseedsedu.webp'" alt="wonderseedsedu.com" />
              <a href="https://wonderseedsedu.com/" target="_blank" rel="noopener">
                {{ t('Visit Website') }}
              </a>
            </figure>
            <a href="https://wonderseedsedu.com/" target="_blank" rel="noopener">
              <h5 class="mb-0">wonderseedsedu.com</h5>
            </a>
            <p>{{ t('Educational') }}, {{ t('Portal') }}, {{ t('Catalog') }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
@import '~/_variables.scss';

.portfolio {
  .title {
    margin: 0 auto 3rem;
    max-width: 600px;
    text-align: center;
  }

  h5 {
    color: #666;
  }

  .project {
    margin-bottom: 3rem;
    position: relative;
    text-align: center;

    figure {
      margin-bottom: 1rem;
      position: relative;

      img {
        border-radius: 0.5rem;
        box-shadow: 0 0.25rem 0.25rem 0 rgb(25, 25, 25, 0.05);
        height: 250px;
        object-fit: cover;
        object-position: top;
        overflow: hidden;
        width: 100%;
      }

      a {
        background: #222;
        border-radius: 0.5rem;
        color: #fff;
        display: none;
        font-weight: 500;
        left: calc(50% - 63px);
        padding: 0.5rem 1rem;
        position: absolute;
        top: calc(50% - 20px);
        transition: all 0.25s;

        &:hover {
          background: $secondary;
        }
      }

      &:hover {
        a {
          display: block;
        }
      }
    }

    &.new {
      &::before {
        background-color: $secondary;
        border-radius: 0.25rem;
        box-shadow: 0 0.25rem 0.5rem rgb(253 13 110 / 50%);
        color: #fff;
        content: 'New';
        font-size: 0.85rem;
        font-weight: 500;
        left: -0.5rem;
        padding: 0 0.5rem;
        position: absolute;
        top: 0.5rem;
        z-index: 5;
      }
    }
  }
}
</style>

<script>
import VanillaTilt from 'vanilla-tilt';
import { useI18n } from 'vue-i18n';

export default {
  mounted() {
    VanillaTilt.init(document.querySelectorAll('.portfolio .project img'), {
      'max-glare': 0.25,
      glare: true,
      max: 5,
      scale: 1
    });
  },

  setup() {
    const { t } = useI18n({
      messages: {
        'en-MY': {
          'E-Commerce': 'E-Commerce',
          'Visit Website': 'Visit Website',
          "Despite being a fresh startup, we've experiences working with big brands and corporates. Check out our previous project, or simply take a look of our own website. You can certainly feel the differences.": "Despite being a fresh startup, we've experiences working with big brands and corporates. Check out our previous project, or simply take a look of our own website. You can certainly feel the differences.",
          "Enough Talking, Let's See What Matters The Most.": "Enough Talking, Let's See What Matters The Most.",
          "What We've Done So Far": "What We've Done So Far",
          Business: 'Business',
          Catalog: 'Catalog',
          Educational: 'Educational',
          Informational: 'Informational',
          Portal: 'Portal'
        },
        'zh-MY': {
          'E-Commerce': '电商',
          'Visit Website': '访问网站',
          "Despite being a fresh startup, we've experiences working with big brands and corporates. Check out our previous project, or simply take a look of our own website. You can certainly feel the differences.": '尽管我们是一家新兴公司，但我们与各大品牌的公司合作经验丰富。您可以查看曾经与我们合作过的公司以及其项目，又或者是浏览看看我们本身的网站。我们相信眼尖的您自然可以发现其中的差异。',
          "Enough Talking, Let's See What Matters The Most.": '话不多说，让我们看看什么才是最重要的。',
          "What We've Done So Far": '到目前为止我们所做的',
          Business: '商务',
          Catalog: '目录',
          Educational: '教育',
          Informational: '咨询',
          Portal: '门户'
        },
        'ms-MY': {
          'E-Commerce': 'E-dagang',
          'Visit Website': 'Melawat laman web',
          "Despite being a fresh startup, we've experiences working with big brands and corporates. Check out our previous project, or simply take a look of our own website. You can certainly feel the differences.": 'Walaupun kami sesuatu syarikat permulaan yang baru, kami telah bekerjasama dengan syarikat-syarikat besar. Mari lihat projek kami setakat ini, atau cuba lihat laman web kami sendiri. Kami pasti anda akan mendapati perbezaan kami.',
          "Enough Talking, Let's See What Matters The Most.": 'Tanpa basa-basi lagi, mari kita lihat apa yang paling penting.',
          "What We've Done So Far": 'Projek Kami Setakat Ini',
          Business: 'Business',
          Catalog: 'Katalog',
          Educational: 'Pendidikan',
          Informational: 'Maklumat',
          Portal: 'Portal'
        }
      }
    });

    return { t };
  }
};
</script>
